export const RichTextIcons = {
  FIBRE: '::fibre::',
  CALCIUM: '::calcium::',
  PROTEIN: '::protein::',
  SPEED: '::speed::',
  SP: '::sp::',
  WHOLEGRAIN: '::wholegrain::',
};
